import axios from "axios";
axios.defaults.withCredentials = true;


const API_URL = process.env.REACT_APP_AUTH_API_URL;

const register = (username, email, password) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
  }); 
};

const login = (username, password, totp, backupCode) => {
  // A4 – optionaler zweiter Faktor. totp/backupCode werden nur mitgesendet,
  // wenn vorhanden; ohne gueltigen accessToken (z. B. twoFactorRequired) wird
  // KEIN Benutzer gespeichert.
  const payload = { username, password };
  if (totp) payload.totp = totp;
  if (backupCode) payload.backup_code = backupCode;
  return axios
    .post(API_URL + "signin", payload)
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        if (response.data.extId) {
          localStorage.setItem("extId", JSON.stringify(response.data));
        }
      }
      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("extId");
};

const authService = {
  register,
  login,
  logout,
};

export default authService;
